import React from "react";
import Navbar from "./Navbar";
import "./style/Features.css";

const Features = () => {
  return (
    <div className="features__main__container">
      <Navbar />
    </div>
  );
};

function feature ()  {
  return (
      <div className="feature component__space" id="Features">
          <div className="heading">
              <h1 className="heading">Our Awesome Features</h1>
              <p className="heading p__color">
               Discover the Power of Efficiency - Explore BoQ's cutting-edge website features, 
              </p>
              <p className="heading p__color">
              designed to streamline your experience and empower your financial journey.
              </p>
          </div>

          <div className="container">
              <div className="row">


                  <div className="col__3">
                       <div className="feature__box pointer">
                          <div className="icon">
                          <svg
                stroke="currentColor"
                fill="none"
                stroke-width="2"
                viewBox="0 0 24 24"
                stroke-linecap="round"
                stroke-linejoin="round"
                height="1em"
                width="1em"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M2 16.1A5 5 0 0 1 5.9 20M2 12.05A9 9 0 0 1 9.95 20M2 8V6a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-6"></path>
                <line x1="2" y1="20" x2="2" y2="20"></line>
              </svg>
                          </div>
                          <div className="feature__meta">
                              <h1 className="feature__text">Comprehensive Quantity Breakdown</h1>
                              <p className="p feature__text p__color">
                              Provide a detailed breakdown of quantities for
                              </p>
                              <p className="p feature__text p__color">
                              all items in the project, including materials
                              </p>
                              <p className="feature__text p__color">
                              and other resources required.
                              </p>
                          </div>
                       </div>
                  </div>

                  <div className="col__3">
                       <div className="feature__box pointer">
                          <div className="icon">
                          <svg
                stroke="currentColor"
                fill="none"
                stroke-width="2"
                viewBox="0 0 24 24"
                stroke-linecap="round"
                stroke-linejoin="round"
                height="1em"
                width="1em"
                xmlns="http://www.w3.org/2000/svg"
              >
                <polygon points="12 2 2 7 12 12 22 7 12 2"></polygon>
                <polyline points="2 17 12 22 22 17"></polyline>
                <polyline points="2 12 12 17 22 12"></polyline>
              </svg>
                          </div>
                          <div className="feature__meta">
                              <h1 className="feature__text">Easy Navigation</h1>
                              <p className="p feature__text p__color">
                              Ensure the webpage is user-friendly with
                              </p>
                              <p className="p se__text p__color">
                              a simple and intuitive layout that allows users
                              </p>
                              <p className="p feature__text p__color">
                              to find the information they need quickly.
                              </p>
                          </div>
                       </div>
                  </div>

                  <div className="col__3">
                       <div className="feature__box pointer">
                          <div className="icon">
                          <svg
                stroke="currentColor"
                fill="none"
                stroke-width="2"
                viewBox="0 0 24 24"
                stroke-linecap="round"
                stroke-linejoin="round"
                height="1em"
                width="1em"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                <circle cx="9" cy="7" r="4"></circle>
                <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
                <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
              </svg>
                          </div>
                          <div className="feature__meta">
                              <h1 className="feature__text">Mobile Compatibility</h1>
                              <p className="p feature__text p__color">
                              Our webpage and the BoQ are accessible and 
                              </p>
                              <p className="p feature__text p__color">
                              optimized for mobile devices,
                              </p>
                              <p className="p feature__text p__color">
                              allowing users to view information on the go.
                              </p>
                          </div>
                       </div>
                  </div>

                  <div className="col__3">
                       <div className="feature__box pointer">
                          <div className="icon">
                          <svg
                stroke="currentColor"
                fill="none"
                stroke-width="2"
                viewBox="0 0 24 24"
                stroke-linecap="round"
                stroke-linejoin="round"
                height="1em"
                width="1em"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect x="2" y="3" width="20" height="14" rx="2" ry="2"></rect>
                <line x1="8" y1="21" x2="16" y2="21"></line>
                <line x1="12" y1="17" x2="12" y2="21"></line>
              </svg>
                          </div>
                          <div className="feature__meta">
                              <h1 className="feature__text">Security and Privacy</h1>
                              <p className="p feature__text p__color">
                              Our webpage ensures data security
                              </p>
                              <p className="p feature__text p__color">
                              and privacy for users, especially as
                              </p>
                              <p className="p feature__text p__color">
                              sensitive project information is involved.
                              </p>
                          </div>
                       </div>
                  </div>

                  <div className="col__3">
                       <div className="feature__box pointer">
                          <div className="icon">
                          <svg
                stroke="currentColor"
                fill="none"
                stroke-width="2"
                viewBox="0 0 24 24"
                stroke-linecap="round"
                stroke-linejoin="round"
                height="1em"
                width="1em"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                <circle cx="9" cy="7" r="4"></circle>
                <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
                <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
              </svg>
                          </div>
                          <div className="feature__meta">
                              <h1 className="feature__text">Accurate Cost Estimation</h1>
                              <p className="p feature__text p__color">
                              We assure that the BoQ Master provides 
                              </p>
                              <p className="p feature__text p__color">
                              precise cost estimates for the project,
                              </p>
                              <p className="p feature__text p__color">
                              aiding in budget planning and cost control.
                              </p>
                          </div>
                       </div>
                  </div>

                  <div className="col__3">
                       <div className="feature__box pointer">
                          <div className="icon">
                          <svg
                stroke="currentColor"
                fill="none"
                stroke-width="2"
                viewBox="0 0 24 24"
                stroke-linecap="round"
                stroke-linejoin="round"
                height="1em"
                width="1em"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect x="2" y="3" width="20" height="14" rx="2" ry="2"></rect>
                <line x1="8" y1="21" x2="16" y2="21"></line>
                <line x1="12" y1="17" x2="12" y2="21"></line>
              </svg>
                          </div>
                          <div className="feature__meta">
                              <h1 className="feature__text">Up-to-Date Pricing</h1>
                              <p className="p feature__text p__color">
                              Our BoQ Master website incorporates current market prices 
                              </p>
                              <p className="p feature__text p__color">
                              for materials ensuring
                              </p>
                              <p className="p feature__text p__color">
                              the estimates are relevant and reliable.
                              </p>
                          </div>
                       </div>
                  </div>

              </div>
          </div>
      </div>
  )
}

export default Features;
